<template>
    <div>
        <button class="cookie-open-btn" v-show="!show" @click="show = true">
            <i class="las la-cookie-bite"></i>
        </button>

        <div class="cookie-bar-wrap" :class="{ show: show }">
            <div class="cookie-bar">
                <h4 class="cookie-bar-title">Cookie Policy</h4>
                <div class="cookie-bar-text">
                    Il nostro sito utilizza i cookies per garantirti la migliore esperienza nella navigazione.
                </div>

                <div class="cookie-bar-action">
                    <button class="btn btn-cookie-settings" @click="onShowCookieSettings">
                        Maggiori Informazioni
                    </button>

                    <div>
                        <button class="btn btn-primary btn-accept mr-2" @click="reject">
                            Rifiuta
                        </button>

                        <button class="btn btn-primary btn-accept" @click="accept">
                            Accetta
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <Dialog
            header="Impostazioni Cookie"
            :visible.sync="showCookieSettings"
            modal
            :closeOnEscape="false"
            :closable="false"
            :style="{ width: '90vw', maxWidth:'900px' }"
        >
            <template #header>
		        <h3>Impostazioni dei Cookie</h3>
	        </template>

            <p class="mb-3">
                Le seguenti impostazioni ti consentono di esprimere le tue preferenze sui cookie che utilizziamo.
                Per ulteriori informazioni in merito al funzionamento di tali strumenti di tracciamento, fai riferimento alla nostra <a :href="url" target="_blank">cookie policy</a>.
                Puoi rivedere e modificare le tue scelte in qualsiasi momento.
            </p>

            <div class="cookie-settings-btns">
                <button class="btn btn-secondary mr-2" @click="rejectAll"><i class="las la-times mr-1"></i>Rifiuta tutti</button>
                <button class="btn btn-primary" @click="acceptAll"><i class="las la-check mr-1"></i> Accetta tutti</button>
            </div>

            <div class="cookie-type" v-for="(type) in types" :key="type.id">
                <div class="cookie-type-title">
                    <h5>{{ type.name }}</h5>
                    <InputSwitch v-model="preferences[type.id]" :disabled="type.required" @change="onChange" />
                </div>
                <p class="cookie-type-text">
                    {{ type.description }}
                </p>
            </div>

            <template #footer>
                <button class="btn btn-primary btn-accept" @click="savePreferences">
                    Salva e continua
                </button>
            </template>

        </Dialog>
    </div>
</template>

<script>
import Dialog from 'primevue/dialog';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import InputSwitch from 'primevue/inputswitch';
import axios from 'axios';

export default {
    components: {
        Dialog,
        Accordion,
        AccordionTab,
        InputSwitch,
    },

    props: ['types', 'url'],

    data() {
        return {
            preferences: {},
            show: false,
            showCookieSettings: false,
            checked: false,
        };
    },

    created() {
        // let preferences = localStorage.getItem('cookie-preferences');
        let preferences = this.getCookie('cookie_consent');
        if (preferences) {
            preferences = JSON.parse(preferences);

            this.types.forEach(type => {
                if (type.required) {
                    this.preferences[type.id] = true;
                } else if (preferences[type.id]) {
                    this.preferences[type.id] = true;
                } else {
                    this.preferences[type.id] = false;
                }
            });

        } else {
            this.types.forEach(type => {
                this.preferences[type.id] = true;
            });
            setTimeout(() => {
                this.show = true;
            }, 300);
        }
    },

    mounted() {
    },

    methods: {
        accept() {
            this.show = false;
            const preferences = {};
            this.types.forEach(type => {
                preferences[type.id] = true;
            });
            this.preferences = preferences;

            this.saveConsent();
        },

        reject() {
            this.show = false;

            const preferences = {};
            this.types.forEach((type, i) => {
                if (type.required) {
                    preferences[type.id] = true;
                } else {
                    preferences[type.id] = false;
                }
            });
            this.preferences = preferences;

            this.saveConsent();
        },

        onShowCookieSettings() {
            this.show = false;
            this.showCookieSettings = true;
        },

        rejectAll() {
            const preferences = {};
            this.types.forEach(type => type.required ? preferences[type.id] = true : preferences[type.id] = false);
            this.preferences = preferences;
        },

        acceptAll() {
            const preferences = {};
            this.types.forEach(type => preferences[type.id] = true);
            this.preferences = preferences;
        },

        savePreferences() {
            this.saveConsent();
            this.showCookieSettings = false;
        },

        saveConsent() {
            // window.localStorage.setItem('cookie-preferences', JSON.stringify(this.preferences));
            this.setCookie('cookie_consent', JSON.stringify(this.preferences), 365);

            // axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            axios({
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': FleetCart.csrfToken,
                },
                data: {
                    preferences: this.preferences,
                },
                url: route('cookie_consent.store'),
            }).catch(error => {
                window.console.error(error);
            });
        },

        onChange() {
            this.preferences = {
                ...this.preferences,
            };
        },

        setCookie(name, value, days) {
            var expires;
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = '; expires=' + date.toGMTString();
            }
            else {
                expires = '';
            }
            document.cookie = name + '=' + value + expires + '; path=/';
        },

        getCookie(c_name) {
            if (document.cookie.length > 0) {
                let c_start = document.cookie.indexOf(c_name + '=');
                if (c_start !== -1) {
                    c_start = c_start + c_name.length + 1;
                    let c_end = document.cookie.indexOf(';', c_start);
                    if (c_end === -1) {
                        c_end = document.cookie.length;
                    }
                    return unescape(document.cookie.substring(c_start, c_end));
                }
            }
            return null;
        },

        log() {
            window.console.log(this.preferences);
        },
    },
};
</script>

